import React, { useState, useEffect } from "react";
import moment from "moment";
import MeetingRoomSingleMic from "./MeetingRoomSingleMic";
import { drAppointment, makeAppoinment } from "../../../api/apiHandler";
import Swal from "sweetalert2";
import PatientNameModal from "../../../modal/PatientModal/PatientModal";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
const MeetingInitialize = () => {
  const [data, setData] = useState(null);
  const [patientName, setPatientName] = useState("");
  const [showIsNameModal, setShowIsNameModal] = useState(false);
  const location = useLocation();
  const meeting_data = location.state;
  console.log("meestisng_datsa", meeting_data);
  // console.log(patientName, "patientNamefromface");
  let handleBookAppointment = (patienDetails) => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    let bookAppointmentObj = {
      appointment_date: moment().utc().format("YYYY-MM-DD"),
      appointment_time: moment().utc().format("hh:mm A"),
      is_schedule: 1,
      patient_id: patienDetails.id,
    };
    console.log(patienDetails, "patientNamefromface", bookAppointmentObj);

    drAppointment(bookAppointmentObj)
      .then((res) => {
        const response = JSON.parse(res);

        if (response.code === 200) {
          console.log("AppointmentResponse", response);
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: response.message || "Appointment booked successfully!",
            toast: true,
            showConfirmButton: false,
            timer: 5000,
          });

          const startMeetingObj = {
            name: localStorage.getItem("user_name"),
            email: localStorage.getItem("user_email"),
            appointment_id: response.data?.id,
            start_meeting: 1,
          };

          setData(startMeetingObj);
          setShowIsNameModal(false);
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message || "Failed to book appointment",
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
      .catch((error) => {
        console.error("Error while booking appointment:", error);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Something went wrong. Please try again.",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

  useEffect(() => {
    if (meeting_data?.meeting_id) {
      setShowIsNameModal(false);
    } else {
      setShowIsNameModal(true);
      localStorage.setItem("meeting_room", "/meeting-single-mic");
    }
  }, [meeting_data?.meeting_id]);

  return (
    <>
      {showIsNameModal &&
        createPortal(
          <PatientNameModal
            patientName={patientName}
            setPatientName={setPatientName}
            setShowIsNameModal={setShowIsNameModal}
            showIsNameModal={showIsNameModal}
            handleSave={handleBookAppointment}
          />,
          document.body
        )}
      <MeetingRoomSingleMic
        data={data !== null ? data : meeting_data}
        handleBookAppointment={handleBookAppointment}
        setShowIsNameModal={setShowIsNameModal}
        showIsNameModal={showIsNameModal}
        patientName={patientName}
      />
    </>
  );
};
export default MeetingInitialize;
